import { useState, useEffect } from "react";
import { IoNotifications } from "react-icons/io5";
import { useAppDispatch, useAppSelector } from "../../utils/hooks";
import { updateViewState } from "../../store/Slices/ViewManagerSlice";
import { useTranslateText } from "../../hooks/useTranslateText";

const NotificationToggleFromSettings = () => {
  const dispatch = useAppDispatch();
  const translate = useTranslateText();
  const [permission, setPermission] =
    useState<NotificationPermission>("default");

  const showModal = useAppSelector(
    (state) => state.ViewManager.show_enable_notifications_modal,
  );

  useEffect(() => {
    if ("Notification" in window) {
      setPermission(Notification.permission);
    }
  }, [showModal]);

  if (!("Notification" in window)) return null;

  const enabled = permission === "granted";

  const handleClick = () => {
    if (!enabled) {
      dispatch(updateViewState({ show_enable_notifications_modal: true }));
    }
  };

  return (
    <button
      type="button"
      className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left active:bg-black/[0.04] dark:active:bg-white/[0.06]"
      onClick={handleClick}
    >
      <div className="flex items-center gap-3">
        <IoNotifications className="text-xl text-themeColor" />
        <span className="text-[15px] text-darkText">
          {translate("Notification")}
        </span>
      </div>
      <span
        className={`relative h-[28px] w-[48px] shrink-0 rounded-full transition-colors ${
          enabled ? "bg-themeColor" : "bg-black/15 dark:bg-white/20"
        }`}
      >
        <span
          className={`absolute top-[2px] h-6 w-6 rounded-full bg-white shadow transition-transform ${
            enabled ? "translate-x-[22px]" : "translate-x-[2px]"
          }`}
        />
      </span>
    </button>
  );
};

export default NotificationToggleFromSettings;
